/* Joulebody new look: lazy video loops, ingredient tabs, quick add to bag, Klaviyo signup. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Videos carry data-src and only load and play while near the screen. */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-jb-lazy]');
    if (!vids.length) return;
    if (reduceMotion) {
      vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { load(v); play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { load(v); play(v); } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }
  function load(v) {
    if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.load(); }
  }
  function play(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Ingredient explorer: each tab swaps the video and the fact. */
  function initExplorer(root) {
    (root || document).querySelectorAll('[data-jb-explorer]').forEach(function (ex) {
      var tabs = ex.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { select(ex, tab); });
        tab.addEventListener('keydown', function (e) {
          var list = Array.prototype.slice.call(tabs);
          var i = list.indexOf(tab);
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var next = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
            next.focus();
            select(ex, next);
          }
        });
      });
    });
  }
  function select(ex, tab) {
    var key = tab.dataset.key;
    ex.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    ex.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== key; });
    ex.querySelectorAll('[data-media]').forEach(function (m) {
      var on = m.dataset.media === key;
      m.hidden = !on;
      var v = m.querySelector('video');
      if (!v) return;
      if (on && !reduceMotion) { load(v); play(v); } else { v.pause(); }
    });
  }

  /* Quick add: posts to the cart and opens Dawn's cart drawer when it is on the page. */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-jb-add]');
      if (!form) return;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      var body = new FormData(form);
      var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.append('sections', sections);
      body.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { form.submit(); return; }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* Email signup straight to the existing Klaviyo list. */
  function initSignup(root) {
    (root || document).querySelectorAll('form[data-jb-klaviyo]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]').value.trim();
        var msg = form.querySelector('[data-jb-msg]');
        var btn = form.querySelector('button');
        if (!email) return;
        btn.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: form.dataset.source || 'Website signup',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
            }
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            form.reset();
            msg.textContent = form.dataset.success;
          })
          .catch(function () { msg.textContent = form.dataset.error; })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* Product row arrows: scroll by about two cards and switch off at either end. */
  function initTracks(root) {
    (root || document).querySelectorAll('[data-jb-track]').forEach(function (track) {
      var sec = track.closest('section');
      var prev = sec.querySelector('[data-jb-scroll="prev"]');
      var next = sec.querySelector('[data-jb-scroll="next"]');
      if (!prev || !next) return;
      function step() {
        var item = track.firstElementChild;
        return item ? (item.getBoundingClientRect().width + 40) * 2 : track.clientWidth * 0.8;
      }
      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Product page: gallery thumbs, pack choice, variant choice, quantity and the running total. */
  function money(cents, fmt) {
    var amt = (cents / 100).toFixed(2);
    var plain = amt.replace(/\.00$/, '');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*\w+\s*\}\}/, plain);
  }
  function initPdp(root) {
    (root || document).querySelectorAll('[data-jb-pdp]').forEach(function (pdp) {
      var fmt = pdp.dataset.money;
      var main = pdp.querySelector('[data-jb-main]');
      var img = main && main.querySelector('img');
      pdp.querySelectorAll('[data-jb-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!img) return;
          img.removeAttribute('srcset');
          img.src = t.dataset.src;
          img.alt = t.dataset.alt || '';
          main.classList.toggle('is-cut', t.dataset.cut === 'true');
          pdp.querySelectorAll('[data-jb-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
        });
      });
      var idInput = pdp.querySelector('[data-jb-variant]');
      var qty = pdp.querySelector('[data-jb-qty-input]');
      var priceEl = pdp.querySelector('[data-jb-price]');
      var sizeEl = pdp.querySelector('[data-jb-size]');
      var totalEl = pdp.querySelector('[data-jb-total]');
      var unit = null;
      function refresh() {
        var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        if (unit !== null && totalEl) totalEl.textContent = money(unit * q, fmt);
      }
      function choose(variant, price, size) {
        if (idInput) idInput.value = variant;
        unit = parseInt(price, 10);
        if (priceEl) priceEl.textContent = money(unit, fmt);
        if (sizeEl && size !== undefined) sizeEl.textContent = size;
        refresh();
      }
      var packs = pdp.querySelectorAll('[data-jb-pack]');
      packs.forEach(function (b) {
        if (b.getAttribute('aria-checked') === 'true') unit = parseInt(b.dataset.price, 10);
        b.addEventListener('click', function () {
          packs.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
          choose(b.dataset.variant, b.dataset.price, b.dataset.size);
        });
      });
      var sel = pdp.querySelector('[data-jb-select]');
      if (sel) {
        unit = parseInt(sel.selectedOptions[0].dataset.price, 10);
        sel.addEventListener('change', function () { choose(sel.value, sel.selectedOptions[0].dataset.price); });
      }
      if (unit === null && totalEl) unit = Math.round(parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) * 100);
      pdp.querySelectorAll('[data-jb-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.jbQty, 10));
          refresh();
        });
      });
      if (qty) qty.addEventListener('input', refresh);
    });
  }

  function init(root) { initVideos(root); initExplorer(root); initSignup(root); initTracks(root); initPdp(root); }

  document.addEventListener('DOMContentLoaded', function () { init(document); initQuickAdd(); });
  /* Re-run when a section is edited in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
